"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["SetSkinTone"] = "SET_SKIN_TONE";
    ActionType["SetSelectedSex"] = "SET_SELECTED_SEX";
    ActionType["SetSelectedPhenotype"] = "SET_SELECTED_PHENOTYPE";
    ActionType["SetPreviewImage"] = "SET_PREVIEW_IMAGE";
    ActionType["SetIsOnboarding"] = "SET_IS_ONBOARDING";
})(ActionType || (exports.ActionType = ActionType = {}));
